import { render, staticRenderFns } from "./FreelancerDraftsTab.htm?vue&type=template&id=9fc26f84&scoped=true&"
import script from "./FreelancerDraftsTab.ts?vue&type=script&lang=js&"
export * from "./FreelancerDraftsTab.ts?vue&type=script&lang=js&"
import style0 from "../MyGigsTab.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./FreelancerDraftsTab.scss?vue&type=style&index=1&id=9fc26f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc26f84",
  null
  
)

export default component.exports